import React from 'react';
import PeptideSlideshow from '@/components/peptides/PeptideSlideshow';
import { bpc157Data } from '@/data/peptidesData';

export default function BPC157ModularContent() {
  return <PeptideSlideshow {...bpc157Data.componentData} />;
}